import { UpperCasePipe } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Component, computed, Signal, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { ConditionProcessorUtil } from '@iot-platform/iot-platform-utils';
import { TranslatePipe } from '@ngx-translate/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { get } from 'lodash';

type CallToActionHeaderParams = IHeaderParams & {
  visibleConditions: unknown[];
  bulkActions: unknown[];
  userPermissions: unknown[];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  dispatchEvent: Function;
};

@Component({
  selector: 'grid-engine-call-to-action-header',
  templateUrl: './call-to-action-header.component.html',
  imports: [FlexLayoutModule, MatIcon, MatMenuTrigger, MatIconButton, MatMenu, MatDivider, UpperCasePipe, MatMenuItem, TranslatePipe, MatTooltip],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./call-to-action-header.component.scss']
})
export class CallToActionHeaderComponent implements IHeaderAngularComp {
  params: WritableSignal<CallToActionHeaderParams> = signal(null);
  canShowBulkButton: Signal<boolean> = computed(() => {
    const params = this.params();
    return !!params?.api?.getSelectedRows()?.length;
  });
  bulkActions: Signal<any[]> = computed(() => {
    const params = this.params();
    return get(params, ['bulkActions'], []);
  });
  visibleConditions: Signal<any[]> = computed(() => {
    const params = this.params();
    return get(params, ['visibleConditions'], []);
  });
  userPermissions: Signal<any[]> = computed(() => {
    const params = this.params();
    return get(params, ['userPermissions'], []);
  });
  bulkActionVisibility: Signal<any[]> = computed(() => {
    const bulkActions = this.bulkActions();
    const userPermissions = this.userPermissions();
    return bulkActions?.reduce((acc, value) => {
      acc[value.key] = ConditionProcessorUtil.processConditionsWithPermission(value.visibleConditions, userPermissions);
      return acc;
    }, {});
  });
  isCallToActionVisible: Signal<boolean> = computed(() => {
    const visibleConditions = this.visibleConditions();
    const userPermissions = this.userPermissions();
    return ConditionProcessorUtil.processConditionsWithPermission(visibleConditions, userPermissions);
  });

  agInit(params: CallToActionHeaderParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }

  onBulkActionClick(type: string): void {
    const params = this.params();
    params.dispatchEvent({ type, rawData: params.api.getSelectedRows(), options: {} });
  }
}
